<form class="m-form m-form--fit m-form--label" [formGroup]="tpRuleCreationForm">

		<div class="row">
	
			<div class="col-9 form-group m-form__group m--margin-top-10 form_header">
				Existing Training Partner Type and Fee Payment Setup Info:
			</div>
			<div class="m-portlet__head-tools col-3">
				<a class="m-portlet__nav-link btn btn-secondary pull-right blueColor" *ngIf="!isAdmin" (click)="addTrainingPartnerType()"
				 data-target="#trainingpartner_type_modal" data-toggle="modal">
					Add Another Training Partner Type
				</a>
			</div>
		</div>
	
	
	
		<div *ngFor="let rule of tpRuleCreationForm.get('rulesForType')['controls']; let i = index;" formArrayName="rulesForType">
			<div [formGroupName]="i">
				<div class="form-group m-form__group m--margin-top-10 form_header">
					{{i+1}}. Training Parter Type {{tpRuleDetails.rulesForType[i].type}}
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Registration Fee (Rs.):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select [disabled]="isDisabled()" (ngModelChange)="setValidation($event, tpRuleCreationForm.get('rulesForType').controls[i].get('registrationAmount'))"
						 name="trainingCentre" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tpRuleDetails.rulesForType[i].registration.isPaymentRequired"
						 formControlName="registrationAmountIsRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tpRuleCreationForm.get('rulesForType').controls[i].get('registrationAmountIsRequired')"
						 [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[i].registration.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number" placeholder="Enter the amount needs to be paid"
							 [(ngModel)]="tpRuleDetails.rulesForType[i].registration.amount" formControlName="registrationAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" min="0" 
							 onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
							<app-form-control-messages [control]="tpRuleCreationForm.get('rulesForType').controls[i].get('registrationAmount')"
							 [name]="'Amount'"></app-form-control-messages>
	
						</div>
					</div>
				</div>
	
	
	
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Un-Blocking Fee:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-4">
						<select (ngModelChange)="setValidation($event, tpRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmount'))"
						 [disabled]="isDisabled()" name="trainingCentre" class="form-control m-input" id="exampleSelect1"
						 formControlName="unblockingAmountIsRequired" [(ngModel)]="tpRuleDetails.rulesForType[i].unBlocking.isPaymentRequired">
							<option value="" disabled>Select Payment Required or Not</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<app-form-control-messages [control]="tpRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmountIsRequired')"
						 [name]="'Option'"></app-form-control-messages>
					</div>
					<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[i].unBlocking.isPaymentRequired=='Yes'">
						<div class="col-1 col-form-label">Rs.</div>
						<div class="col-10">
							<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
							 placeholder="Enter the amount needs to be paid" [(ngModel)]="tpRuleDetails.rulesForType[i].unBlocking.amount"
							 formControlName="unblockingAmount" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							 maxlength="8" minlength="0" onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
							<app-form-control-messages [control]="tpRuleCreationForm.get('rulesForType').controls[i].get('unblockingAmount')"
							 [name]="'Amount'"></app-form-control-messages>
						</div>
					</div>
				</div>
	
	
				<div class="row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
					</label>
					<div class="col-4">
						<a class="text-Centre blueColor" *ngIf='tpRuleDetails.rulesForType.length>1' (click)="removeTrainingPartnerType(i)">Remove Training Partner Type</a>
					</div>
				</div>
	
	
	
			</div>
			<div class="m-form__seperator m-form__seperator--dashed" style="margin-top:5px;"></div>
		</div>
	
		<!-- <div class="form-group m-form__group m--margin-top-10 form_header">
				1. Training Partner Type "Regular"
			</div>
			<div class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Registration Fee (Rs.):
					<span class="mandatoryColor">*</span>
				</label>
				<div class="col-4">
					<select (ngModelChange)="setValidation($event, tpRuleCreationForm.controls.regularRegistrationAmount)" [disabled]="isDisabled()"
						name="trainingPartner" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tpRuleDetails.rulesForType[0].registration.isPaymentRequired"
						formControlName="regularRegistrationAmountIsRequired">
						<option value="" disabled>Select Payment Required or Not</option>
						<option value="Yes">Yes</option>
						<option value="No">No</option>
					</select>
					<app-form-control-messages [control]="tpRuleCreationForm.controls.regularRegistrationAmountIsRequired" [name]="'Option'"></app-form-control-messages>
				</div>
				<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[0].registration.isPaymentRequired == 'Yes'">
						<div class="col-1 col-form-label">Rs.</div>
					<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number" placeholder="Enter the amount needs to be paid"
						[(ngModel)]="tpRuleDetails.rulesForType[0].registration.amount" formControlName="regularRegistrationAmount">
					<app-form-control-messages [control]="tpRuleCreationForm.controls.regularRegistrationAmount" [name]="'Amount'"></app-form-control-messages>
		</div>
				</div>
			</div>
		
		
		
			<div class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Un-Blocking Fee  (Rs.):
					<span class="mandatoryColor">*</span>
				</label>
				<div class="col-4">
					<select (ngModelChange)="setValidation($event, tpRuleCreationForm.controls.regularUnblockingAmount)" [disabled]="isDisabled()"
						name="trainingPartner" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tpRuleDetails.rulesForType[0].unBlocking.isPaymentRequired"
						formControlName="regularUnblockingAmountIsRequired">
						<option value="" disabled>Select Payment Required or Not</option>
						<option value="Yes">Yes</option>
						<option value="No">No</option>
					</select>
					<app-form-control-messages [control]="tpRuleCreationForm.controls.regularUnblockingAmountIsRequired" [name]="'Option'"></app-form-control-messages>
		
				</div>
				<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[0].unBlocking.isPaymentRequired == 'Yes'">
						<div class="col-1 col-form-label">Rs.</div>
					<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number" placeholder="Enter the amount needs to be paid"
						[(ngModel)]="tpRuleDetails.rulesForType[0].unBlocking.amount" formControlName="regularUnblockingAmount">
					<app-form-control-messages [control]="tpRuleCreationForm.controls.regularUnblockingAmount" [name]="'Amount'"></app-form-control-messages>
		</div>
				</div>
			</div>
		
		
			<div class="form-group m-form__group m--margin-top-10 form_header">
				2. Training Partner Type "Government"
			</div>
			<div class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Registration Fee  (Rs.):
					<span class="mandatoryColor">*</span>
				</label>
				<div class="col-4">
					<select (ngModelChange)="setValidation($event, tpRuleCreationForm.controls.govtRegistrationAmount)" [disabled]="isDisabled()"
						name="trainingPartner" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tpRuleDetails.rulesForType[1].registration.isPaymentRequired"
						formControlName="govtRegistrationAmountIsRequired">
						<option value="" disabled>Select Payment Required or Not</option>
						<option value="Yes">Yes</option>
						<option value="No">No</option>
					</select>
					<app-form-control-messages [control]="tpRuleCreationForm.controls.govtRegistrationAmountIsRequired" [name]="'Option'"></app-form-control-messages>
		
				</div>
				<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[1].registration.isPaymentRequired == 'Yes'">
						<div class="col-1 col-form-label">Rs.</div>
					<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number" placeholder="Enter the amount needs to be paid"
						[(ngModel)]="tpRuleDetails.rulesForType[1].registration.amount" formControlName="govtRegistrationAmount">
					<app-form-control-messages [control]="tpRuleCreationForm.controls.govtRegistrationAmount" [name]="'Amount'"></app-form-control-messages>
		</div>
				</div>
			</div>
		
		
		
			<div class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Un-Blocking Fee  (Rs.):
					<span class="mandatoryColor">*</span>
				</label>
				<div class="col-4">
					<select (ngModelChange)="setValidation($event, tpRuleCreationForm.controls.govtUnblockingAmount)" [disabled]="isDisabled()"
						name="trainingPartner" class="form-control m-input" id="exampleSelect1" [(ngModel)]="tpRuleDetails.rulesForType[1].unBlocking.isPaymentRequired"
						formControlName="govtUnblockingAmountIsRequired">
						<option value="" disabled>Select Payment Required or Not</option>
						<option value="Yes">Yes</option>
						<option value="No">No</option>
					</select>
					<app-form-control-messages [control]="tpRuleCreationForm.controls.govtUnblockingAmountIsRequired" [name]="'Option'"></app-form-control-messages>
		
				</div>
				<div class="col-4 row" *ngIf="tpRuleDetails.rulesForType[1].unBlocking.isPaymentRequired == 'Yes'">
						<div class="col-1 col-form-label">Rs.</div>
					<div class="col-10">
					<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number" placeholder="Enter the amount needs to be paid"
						[(ngModel)]="tpRuleDetails.rulesForType[1].unBlocking.amount" formControlName="govtUnblockingAmount">
					<app-form-control-messages [control]="tpRuleCreationForm.controls.govtUnblockingAmount" [name]="'Amount'"></app-form-control-messages>
		</div>
				</div>
			</div>
		 -->
	
		 <div class="m-portlet__foot m-portlet__foot--fit">
				<div class="form-group m-form__group m--margin-top-10 form_header">
					Block Attempt & Duration Info
				</div>
		
		
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Number of Block Attempts Allowed:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="2" name="mobile-number"
							placeholder="Select how many attempts are allowed if Training Partner is found 'Deemed Not Ready'" [(ngModel)]="tpRuleDetails.blockAttemptAndDuration.noOfBlockAttempts"
							formControlName="noOfBlockAttempts" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tpRuleCreationForm.controls.noOfBlockAttempts" [message]="'Number of Block Attempts Allowed should be not more than 9'"
							[name]="'Allowed Block Attempts'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tpRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Duration of Each Block (in Months):
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="2" name="mobile-number"
							placeholder="Select Duration of Each Block" [(ngModel)]="tpRuleDetails.blockAttemptAndDuration.durationOfBlock" formControlName="durationOfBlock"
							oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tpRuleCreationForm.controls.durationOfBlock" [message]="'Number of Block Allowed should be not more than 12'"
							[name]="'Duration'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tpRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label for="tp-details" class="col-4 col-form-label tc-text-align">
						Number of Days to complete Desktop assessment:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-8">
						<input [disabled]="isDisabled()" class="form-control m-input" type="number" minlength="0" maxlength="3" name="mobile-number"
							placeholder="Select No.of Days in advance Inspection notifications should be sent" [(ngModel)]="tpRuleDetails.blockAttemptAndDuration.noOfDaysToCompleteDesktopAssessment"
							formControlName="noOfDaysToCompleteDesktopAssessment" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return event.charCode >= 48 && event.charCode <= 57 && event.charCode != 45" min="0">
						<app-form-control-messages [control]="tpRuleCreationForm.controls.noOfDaysToCompleteDesktopAssessment" [message]="'Number of Days should be not more than 365'"
							[name]="'Desktop assessment days'"></app-form-control-messages>
		
						<!-- <app-form-control-messages [control]="tpRuleCreationForm.controls.mobileNumber" [name]="'Mobile OF Spoc'"></app-form-control-messages> -->
					</div>
				</div>
			</div>
		<br>
	
		<div class="m-portlet__foot m-portlet__foot--fit">
			<div class="form-group m-form__group row">
				<label class="col-xl-4 col-lg-4 col-form-label">
					Rule Setup Effective Date
				</label>
				<div class="col-xl-8 col-lg-8">
					<div class="input-group date">
						<input [disabled]="isDisabled()" type="text" (blur)="tpRuleDetails.effectiveDate = startDate.value" class="form-control m-input"
						 readonly formControlName="effectiveDate" placeholder="Pick your Date" #startDate id="startDate" [(ngModel)]="tpRuleDetails.effectiveDate" />
						<div class="input-group-append">
							<span class="input-group-text">
								<i class="la la-calendar"></i>
							</span>
						</div>
					</div>
					<app-form-control-messages [control]="tpRuleCreationForm.controls.effectiveDate" [name]="'Effective date'"></app-form-control-messages>
	
				</div>
			</div>
		</div>
		<br>
		<div *ngIf="isAdmin" class="m-portlet__foot m-portlet__foot--fit">
			<div [formGroup]="adminFormGroup" class="form-group m-form__group row">
				<label for="tp-details" class="col-4 col-form-label tc-text-align">
					Review Comments
				</label>
				<div class="col-8">
					<div>
						<label class="m-checkbox">
							<input type="checkbox" [(ngModel)]="approved" (click)="approve(true)" [ngModelOptions]="{standalone: true}">
							Approved
							<!-- <input type="checkbox" [(ngModel)]="approved" (click)="notApproved=false;approved=true" [ngModelOptions]="{standalone: true}"> Approved -->
							<span></span>
						</label>
					</div>
					<div>
						<label class="m-checkbox">
							<input type="checkbox" [(ngModel)]="notApproved" (click)="approve(false)" [ngModelOptions]="{standalone: true}">
							Not Approved
							<!-- <input type="checkbox" [(ngModel)]="notApproved" (click)="approved=false;notApproved=true" [ngModelOptions]="{standalone: true}"> Not Approved -->
							<span></span>
						</label>
					</div>
					<div>
						<textarea class="form-control m-input" placeholder="Enter your comments" [(ngModel)]="comments" formControlName="comments"></textarea>
					</div>
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__foot--fit">
			<div class="m-form__actions">
				<div class="row">
					<div class="col-2"></div>
					<div class="col-10 text-center">
						<button type="submit" class="btn btn-next" (click)="saveRule()" [disabled]="!tpRuleCreationForm.valid || !adminFormGroup.valid">
							Submit
						</button>
						<button type="button" class="btn btn-next" (click)="navigateToDashboard()">
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
	
	
	
	<div class="modal fade" id="trainingpartner_type_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	 aria-hidden="true">
		<form [formGroup]='tpTypeFormGroup' class="m-form m-form--fit m-form--label">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">
							Add Another Training Partner Type
						</h5>
						<button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">
								&times;
							</span>
						</button>
					</div>
					<div class="modal-body">
							<div class="row">
							<h5 class="" id="exampleModalLabel">
									Create a Training Partner Type
								</h5>
								</div>
						<div class="form-group  row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Name of the User Type
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-9">
								<input class="form-control m-input" type="text" name="mobile-number" placeholder="Enter the Name of the User Type"
								 [(ngModel)]="rulesForType.type" formControlName="type">
								<app-form-control-messages [control]="tpTypeFormGroup.controls['type']" [name]="'Type'"></app-form-control-messages>
	
							</div>
						</div>
						<div class="form-group row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Registration Fee:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select [disabled]="isDisabled()" (ngModelChange)="setValidation($event, tpTypeFormGroup.controls['registrationAmount'])"
								 name="trainingCentre" class="form-control m-input" id="exampleSelect1" [(ngModel)]="rulesForType.registration.isPaymentRequired"
								 formControlName="registrationAmountIsRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tpTypeFormGroup.controls['registrationAmountIsRequired']" [name]="'Option '"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.registration.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" name="mobile-number"
									 placeholder="Amount" [(ngModel)]="rulesForType.registration.amount" formControlName="registrationAmount"
									 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0" min="0" 
									 onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45">
									<app-form-control-messages [control]="tpTypeFormGroup.controls['registrationAmount']" [name]="'Amount'"></app-form-control-messages>
	
								</div>
							</div>
						</div>
	
	
						<div class="form-group row">
							<label for="tp-details" class="col-3 col-form-label tc-text-align">
								Un-Blocking Fee:
								<span class="mandatoryColor">*</span>
							</label>
							<div class="col-4">
								<select (ngModelChange)="setValidation($event, tpTypeFormGroup.controls['unblockingAmount'])" [disabled]="isDisabled()"
								 name="trainingCentre" class="form-control m-input" id="exampleSelect1" formControlName="unblockingAmountIsRequired"
								 [(ngModel)]="rulesForType.unBlocking.isPaymentRequired">
									<option value="" disabled>Select Payment Required or Not</option>
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>
								<app-form-control-messages [control]="tpTypeFormGroup.controls['unblockingAmountIsRequired']" [name]="'Option '"></app-form-control-messages>
							</div>
							<div class="col-4 row" *ngIf="rulesForType.unBlocking.isPaymentRequired=='Yes'">
								<div class="col-1 col-form-label">Rs.</div>
								<div class="col-9">
									<input [disabled]="isDisabled()" class="form-control m-input" type="number" maxlength="10" name="mobile-number"
									 placeholder="Amount " [(ngModel)]="rulesForType.unBlocking.amount" formControlName="unblockingAmount"
									 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
									 maxlength="8" minlength="0" 
									 onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 45" min="0">
									<app-form-control-messages [control]="tpTypeFormGroup.controls['unblockingAmount']" [name]="'Amount'"></app-form-control-messages>
								</div>
							</div>
						</div>
	
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">
							Close
						</button>
						<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="addToRuleForType()" [disabled]='!tpTypeFormGroup.valid'>
							Save & Submit
						</button>
					</div>
				</div>
				<!-- </div> -->
			</div>
		</form>
	</div>
	